import { SegmentsEnum } from '@pages/order/surgery-info/SegmentsEnum';



interface SegmentsMapProps {
	selectedSegments: string[],
	onSegmentClick: (regionId: string) => void;
}


const SegmentsMap = (props: SegmentsMapProps) => {
	const { selectedSegments, onSegmentClick } = props;

	return (
		<div className='segments-map'>
			<svg id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" width="450" height="350" viewBox="0 0 450 350">
				<path
					onClick={() => onSegmentClick(SegmentsEnum.tail)}
					id={`segment-block-${SegmentsEnum.tail}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.tail) ? ' active-segment' : ''}`}
					d="m385.44,80.1c-2.01-2.41-5.62-2.63-7.91-.49-5.37,5.05-15.02,14.15-23.86,22.51l13.74,10.83,18.3-26.29c1.39-2,1.28-4.68-.28-6.55Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.wrist)}
					id={`segment-block-${SegmentsEnum.wrist}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.wrist) ? ' active-segment' : ''}`}
					d="m149.98,285.79c.14,2.99.61,5.94,1.4,8.82l.06.21c1.17,4.29,2.25,11.96,2.46,18.54.15,4.81-1.45,9.5-4.51,13.21h22.39l.11-.4.85-8.16c.6-.6,2.5-12.02,2.57-12.86l2.43-26.85h-28.1c.14,2.96.26,5.51.36,7.49Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.back)}
					id={`segment-block-${SegmentsEnum.back}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.back) ? ' active-segment' : ''}`}
					d="m158.58,73.38l-1.39-2.41,8.52,74.6h150.05l9.46-26.15c-26.01-3.52-101.56-13.86-124.85-18.09-18.36-3.34-33.44-18.03-41.79-27.95Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.forearm)}
					id={`segment-block-${SegmentsEnum.forearm}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.forearm) ? ' active-segment' : ''}`}
					d="m149.56,277.13h28.26l3.45-38.13c.22-2.58.78-5.08,1.6-7.49h-35.45c.66,14.44,1.54,33.22,2.13,45.62Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.rump)}
					id={`segment-block-${SegmentsEnum.rump}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.rump) ? ' active-segment' : ''}`}
					d="m362.56,177.55l.07.16.27.64-.3-10.76c-.13-4.66-1.44-9.21-3.8-13.23l-3.11-5.29c-3.74-6.36-3.44-14.33.78-20.39l10.28-14.76-13.93-10.98c-4.58,4.33-8.9,8.41-12.23,11.56-3.82,3.61-8.95,5.4-14.15,5.02l-9.64,26.65,45.77,31.38Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.hock)}
					id={`segment-block-${SegmentsEnum.hock}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.hock) ? ' active-segment' : ''}`}
					d="m422.85,285.34c.52-3.71-.8-7.46-3.58-9.96-.42-.38-.79-.7-1.06-.93l-4.43-3.79-25.88,17.94,5.54,3.93c1.52,1.08,2.47,2.77,2.61,4.63l1.45,20.85c.15,2.18-.4,4.34-1.57,6.16-.33.53-.8.96-1.31,1.32l-1.5,1.09h24l5.73-41.24Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.forepaw)}
					id={`segment-block-${SegmentsEnum.forepaw}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.forepaw) ? ' active-segment' : ''}`}
					d="m146.2,330.31c-.32.38-.7.71-1.11.98l-7.9,5.26c-2.87,1.91-3.82,5.78-1.99,8.7.84,1.35,1.94,2.34,3.05,2.34h25.07c1.72,0,3.2-1.23,3.51-2.92l4.61-16.93h-23.05l-2.2,2.56Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.belly)}
					id={`segment-block-${SegmentsEnum.belly}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.belly) ? ' active-segment' : ''}`}
					d="m166.13,146.74l32.59,66.58c3.83-1.91,8.04-3.03,12.37-3.27l66.21-.55,38.01-62.76h-149.19Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.lowerThigh)}
					id={`segment-block-${SegmentsEnum.lowerThigh}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.lowerThigh) ? ' active-segment' : ''}`}
					d="m411.27,265.65c0-2.21-1.17-4.25-3.08-5.37-7.81-4.56-27.79-16.21-27.79-16.21-7.48-3.74-11.62-10.81-13.92-17.79l-32.4,22.97c4.63,4.08,9.45,7.93,14.49,11.5l38.3,27.13,26.05-18.06c-1.04-1.14-1.66-2.61-1.66-4.17Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.hindpaw)}
					id={`segment-block-${SegmentsEnum.hindpaw}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.hindpaw) ? ' active-segment' : ''}`}
					d="m383.62,333.45c-2.22,1.67-2.57,3.66-2.57,6.43,0,0,0,5.14,5.14,6.43h20.35c2.04,0,3.98-.9,5.28-2.47,4.17-5.04,1.47-3.94,5.02-16.09h-25.34l-7.88,5.7Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.upperThigh)}
					id={`segment-block-${SegmentsEnum.upperThigh}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.upperThigh) ? ' active-segment' : ''}`}
					d="m363.68,206.9c0-.1,0-.19,0-.29l-.7-25.1-1.37-3.18-45.26-31.04-37.67,62.2,4.86-.04h.38c11.04-.06,21.43,5.2,27.92,14.14l6.89,9.49c2.51,3.46,5.3,6.71,8.35,9.7,1.99,1.95,4.03,3.83,6.11,5.69l32.94-23.35c-2.63-8.76-2.47-17.09-2.43-18.2Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.head)}
					id={`segment-block-${SegmentsEnum.head}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.head) ? ' active-segment' : ''}`}
					d="m155.72,68.42l-13.29-23h0c-3.58-7.93-14.06-28.71-29.5-37.97-.74-.45-1.48-.86-2.22-1.24-13.21-6.88-29.42-4.16-40.27,6.05l-9.79,9.21c-3.61,3.39-5.84,7.99-6.29,12.92l-.49,5.41c-.06.69-.42,1.31-.98,1.72l-23.01,16.15c-3.57,2.6-3.81,7.84-.48,10.75l20.82,18.22c2.14,1.88,5.22,2.24,7.74.91l18.11-9.48c3.1-1.62,6.54-2.47,10.03-2.47,1.32,0,2.39,1.07,2.39,2.4,0,1.82,1.95,2.97,3.54,2.1l7.52-4.1c.63-.35,1.33-.36,1.93-.14l6.98,21.67,47.41-27.74-.16-1.37Z"/>
				<path
					onClick={() => onSegmentClick(SegmentsEnum.chest)}
					id={`segment-block-${SegmentsEnum.chest}`}
					className={`segment-block disable-selection${selectedSegments.includes(SegmentsEnum.chest) ? ' active-segment' : ''}`}
					d="m164.82,146.74h-.16l-.03-.29h0s-.2-1.63-.2-1.63h.02s-8.43-73.76-8.43-73.76l-46.35,27.12-.85.46.58,1.77.79,2.45,1.41,4.92c.03.11.07.23.11.34,4.15,10.74,5.79,22.28,4.8,33.75-.23,2.66-.47,5.41-.7,8.09-1.04,11.97,1.07,24,6.12,34.9l7.83,16.9c1.47,3.16,4.25,5.52,7.62,6.44l.32.09c5.27,1.44,8.98,6.08,9.22,11.51.13,3,.29,6.6.47,10.55h35.9c1.87-4.87,4.91-9.25,8.95-12.71,1.69-1.45,3.54-2.69,5.47-3.74l-32.87-67.14Z"/>
			</svg>
		</div>
	);
};

export default SegmentsMap;